const articleContent = document.querySelector('.blocks-container');
const hasBlock = document.querySelector('.block-newsletter');
const hideForm = hasBlock ? hasBlock.dataset.hideForm : false;

if (articleContent && !hideForm && !articleContent.querySelector('.cta-newsletter-article') && hasBlock) {
    const titlesCount = articleContent.querySelectorAll('h2, h3, h4');
    if (titlesCount.length > 0) {
        /* eslint-disable-next-line max-len */
        const middleTitle = titlesCount.length % 2 === 0 ? titlesCount[titlesCount.length / 2] : titlesCount[Math.ceil(titlesCount.length / 2)];
        const popup = document.querySelector('.block-newsletter').outerHTML;
        middleTitle.insertAdjacentHTML('beforebegin', popup);
        const allBlocks = document.querySelectorAll('.block-newsletter');
        allBlocks[allBlocks.length - 1].remove();
    }
}
